import React from 'react';
import PropTypes from 'prop-types';

import { NodeRender } from './node-render';
import './fluent-grid.scss';

export const FluentGridLayout = ({
  page,
  dynamicComponentRender,
}) => (
  <NodeRender
    rootId={page.id}
    node={page}
    dynamicComponentRender={dynamicComponentRender}
  />
);

FluentGridLayout.propTypes = {
  page: PropTypes.shape({
    children: PropTypes.arrayOf(PropTypes.shape({
      type: PropTypes.string.isRequired,
      id: PropTypes.string.isRequired,
      children: PropTypes.array,
    })).isRequired,
  }).isRequired,
  dynamicComponentRender: PropTypes.func.isRequired,
};
